import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess';
import _ from 'lodash';
import { _matchLsTypes } from 'projectSpecific/sports/cnr/reducers/SportsDataReducer';
import { useMatchScheduleOptions } from 'projectSpecific/sports/useHelpers/useMatchScheduleOptions';
import React, { useContext, useEffect, useReducer, useState } from 'react';
import { ParentContext } from '../../../../global/cnr/contexts/ParentContext';
import { sidebarHandlers, sidebarInitialState, sidebarMenuTypes, sidebarReducer, sidebarSliderTypes } from '../../../../global/cnr/reducers/SidebarReducer';
import { getFormattedDate } from '../../../../global/common/dateFormatting';
import { gEnums } from '../../../../global/enums/globalEnums';
import SeasonMatchesProvider, { SeasonMatchesContext } from '../../cnr/contexts/SeasonMatchesContext';
import SportsDataProvider from '../../cnr/contexts/SportsDataContext';
import { SportsSeasonContext } from '../../cnr/contexts/SportsSeasonContext';
import { _matchDisplayTypes } from '../matches/MatchContent';
import { LevelSchedules } from './LevelSchedules';
import { Scoreboard } from './Scoreboard';
import { TeamSchedule } from './TeamSchedule';

const sidebarType = 'matchList';

const _labelSize = 'tiny'

const _sidebarItemTypes = {
  matchDates: 'matchDates',
  districts: 'districts',
  levels: 'levels',
};

export const SportsSchedules = (props) => {

  const {
    _levelDateGroups,
    forBackup,
    forPlayoff,
    matchScheduleDisplayType,
    teamKey,
  } = props;

  let _matchScheduleDisplayType = matchScheduleDisplayType || gEnums.matchScheduleDisplayTypes.clickedDates
  let _useScrollRef = false

  switch (_matchScheduleDisplayType) {
    case gEnums.matchScheduleDisplayTypes.levelTabsFull:
      _useScrollRef = true;
    default:
    // nothing
  }

  // Contexts
  const parentContext = useContext(ParentContext);
  const { states, fns } = parentContext ?? {};
  const { paps_state, appUser_state } = states ?? {};
  const { navigation_fns } = fns ?? {};

  const { appUser } = appUser_state ?? {};
  const appUserAccess = useAppUserAccess();
  const { accessLevel } = appUserAccess ?? {};

  const { profileData } = appUser ?? {};
  const { favs_info } = profileData ?? {};
  const { eventFavs } = favs_info ?? {};
  const { teams: team_favs } = eventFavs ?? {};
  const team_fav_keys = team_favs ? _.keys(team_favs) : null


  // sportsSeasonContext
  const sportsSeasonContext = useContext(SportsSeasonContext);
  const { sportsSeason_state, sportsSeason_handlers } = sportsSeasonContext ?? {};
  const { matches_info, seasonMatches_info } = sportsSeason_state ?? {};
  const _matches_info = forBackup && seasonMatches_info ? seasonMatches_info : matches_info;
  const { matches_groupInfo } = _matches_info ?? {};
  const { levelKeys, levelLatestStartDates, scheduleLevelKeys: _scheduleLevelKeys, levelSectionDateMatches: _levelSectionDateMatches } = matches_groupInfo ?? {};

  // seasonMatchesContext
  const seasonMatchesContext = useContext(SeasonMatchesContext)
  const { seasonMatches_state, seasonMatches_handlers } = seasonMatchesContext ?? {}
  const { matchFilter, _shows_matches, commonMatches } = seasonMatches_state ?? {}

  // const [showMatchHeader, setShowMatchHeader] = useState()
  // const [showMissingOnly, setShowMissingOnly] = useState()
  const [selectedDate, setSelectedDate] = useState()
  const [selectedLevelKey, setSelectedLevelKey] = useState()
  const [showMissingMatches, setShowMissingMatches] = useState()
  const [activeTabIndex, setActiveTabIndex] = useState()
  const [selectedGotoLevel, setSelectedGotoLevel] = useState()

  // const {
  //   teamCalendar: showTeamCalendar,
  //   calendar: showCalendar,
  //   // expand: showExpand,
  //   // newMatch: showNewMatch,
  // } = _shows_matches ?? {}

  // Reducer for Sidebar
  const [sidebar_state, sidebar_dispatch] = useReducer(
    sidebarReducer,
    sidebarInitialState({ sidebarType, handlers: sportsSeason_handlers })
  );

  const sidebar_handlers = sidebarHandlers(sidebar_dispatch);
  const { sidebar_items } = sidebar_state ?? {};
  const { setInit } = sidebar_handlers ?? {};
  const { ms_levels } = sidebar_items ?? {};
  const { selected } = ms_levels ?? {};
  const { itemKey: levelKeySelected } = selected ?? {};

  const _initProps = { sidebarSliderType: sidebarSliderTypes.labeled };

  // const handleShowMissingMatches = () => setShowMissingMatches(!showMissingMatches)

  useEffect(() => {
    setSelectedDate(getFormattedDate(new Date()))
  }, []);

  useEffect(() => {
    setSelectedLevelKey(levelKeySelected)
  }, [levelKeySelected]);

  useEffect(() => {
    if (levelKeys) {
      const levelKeysFiltered = _.without(levelKeys, _matchLsTypes.Non);
      setInit({
        smt: sidebarMenuTypes.three,
        items: levelKeysFiltered,
        as: _sidebarItemTypes.levels,
        includeSearch: true,
        ..._initProps,
      });
    }
  }, [levelKeys]);


  // Path views
  const { pathViews } = paps_state ?? {};

  const { _matchDisplayType, _matchDisplayOptions } = useMatchScheduleOptions({ matchScheduleDisplayType })

  switch (_matchDisplayType) {
    case _matchDisplayTypes.scoreboard:
      return <Scoreboard />
    case _matchDisplayTypes.levelMatches:
      return <LevelSchedules />
    case _matchDisplayTypes.levelOverviewMatches:
    case _matchDisplayTypes.teamMatches:
      return <TeamSchedule
        matchDisplayType={_matchDisplayType}
        matchScheduleDisplayType={matchScheduleDisplayType}
        teamKey={teamKey || pathViews.teams}
      />
    default:
      return <div>{_matchDisplayType}</div>
  }

};

/**
 * 
 * @param {object} props 
 * @returns the MatchSchedule componnent wrapped with SeasonMatchesProvider
 */
const SportsSchedulesProvider = React.memo((props) => {
  return <SportsDataProvider>
    <SeasonMatchesProvider  {...props}>
      <SportsSchedules {...props} />
    </SeasonMatchesProvider>
  </SportsDataProvider>
});

export default SportsSchedulesProvider